<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="fastRect">
      <div class="title">生成测验</div>
      <FieldSelect :list="examList" label="项目" placeholder="请选择考试项目" @change="onSelectExam" />
      <FieldSelect v-model="dataForm.timeLenMinute" :list="timeList" label="有效期" placeholder="请选择考场入口有效期" @change="onSelectTime" />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>限制</span></div>
        <div :style="'color: '+GetColorMain()">
          <van-checkbox v-model="dataForm.isJustStudent" shape="square" :checked-color="GetColorMain()">必须是学员才可参加</van-checkbox>
        </div>
      </div>
      <van-field
        v-model="dataForm.remark"
        clearable
        label="备注"
        maxlength="32"
        placeholder="请填写备注"
      />
    </div>
    <div class="downButton">
      <van-button type="default" :color="GetColorMain()" style="width:100%;" :loading="buttonLoading" @click="onCreate">生成测验入口</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Checkbox } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    TopBar,
    FieldSelect
  },
  data() {
    return {
      titleTop: '',
      title: '新增测验',
      backurl: '/pro/examList',
      buttonLoading: false,
      examList: [],
      timeList: [],
      dataForm: {
        examId: undefined,
        timeLenMinute: undefined,
        remark: '',
        isJustStudent: true
      }
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    setTimeout(() => {
      this.timeList =
    [
      { text: '10分钟', value: '10' },
      { text: '30分钟', value: '30' },
      { text: '1小时', value: '60' },
      { text: '2小时', value: '120' },
      { text: '4小时', value: '240' },
      { text: '6小时', value: '360' },
      { text: '10小时', value: '600' },
      { text: '24小时', value: '1440' }]
      this.dataForm.timeLenMinute = '120'
    }, 1)
    this.initExamList()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initExamList() {
      this.examList = []
      request({
        url: '/DiveLearn/getExamList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        var list = response.data
        list.forEach(item => {
          this.examList.push({
            value: item.examId,
            text: item.title + '[' + item.totalNum + '题]' })
        })
      })
    },
    onSelectExam(value) {
      this.dataForm.examId = value.value
    },
    onSelectTime(value) {
      this.dataForm.timeLenMinute = value.value
    },
    onCreate() {
      if (!this.dataForm.examId) {
        MyNotify('info', '请选择考试项目', 2000)
        return
      }
      this.buttonLoading = true
      request({
        url: '/DiveLearn/AddBeginExam',
        method: 'post',
        data: this.dataForm
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '测验入口生成成功!', 2000)
        this.$router.push('/pro/examInfo/' + response.data.beginId)
      })
    }
  }
}
</script>
<style scoped>
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.downButton{
    position: fixed;
    left: 1em;
     right: 1em;
     bottom: 1em ;
}
</style>
